// extracted by mini-css-extract-plugin
export default {"code":"R_cT"};